module.exports = __webpack_public_path__ + "img/3.0a7ac942.webp";